import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne'
import NavBar from '../nav_bar/Navbar'
import LeadDashboardPage from './LeadDashboardPage'


function LeadDashboard() {
    const [searchUi, setSearchUi] = useState(false)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadDashboardPage/>}
                menuId={1}
            />
        </DataContext.Provider>
    )
}

export default LeadDashboard